"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Card = _interopRequireDefault(require("../../../nav/Card"));

var _TableActionButton = _interopRequireDefault(require("../section/TableActionButton"));

var _styling = require("../../../../toolkit/styling");

var _providers = require("../../../../toolkit/providers");

var _TableMobileCell = _interopRequireDefault(require("./TableMobileCell"));

var _TableMobileRowExpansion = _interopRequireDefault(require("./TableMobileRowExpansion"));

//
//  src/data/table/mobile/TableMobileRow.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 4/1/2020.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */

/* Relative Imports */
var _default = (0, _mobxReact.observer)(function (_ref) {
  var row = _ref.row,
      section = _ref.section,
      columns = _ref.columns,
      rowIndex = _ref.rowIndex,
      className = _ref.className,
      style = _ref.style;
  var styles = useStylesheet();
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    className: (0, _styling.css)(className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.content)
  }, columns.map(function (column, cellIndex) {
    return /*#__PURE__*/_react["default"].createElement(_TableMobileCell["default"], {
      row: row,
      column: column,
      section: section,
      rowIndex: rowIndex,
      cellIndex: cellIndex,
      className: (0, _styling.css)(styles.cell)
    });
  }), /*#__PURE__*/_react["default"].createElement(_TableActionButton["default"], {
    row: row,
    section: section,
    className: (0, _styling.css)(styles.action)
  }), /*#__PURE__*/_react["default"].createElement(_TableMobileRowExpansion["default"], {
    row: row,
    section: section,
    rowIndex: rowIndex
  })));
});

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheme = (0, _providers.useTheme)(),
      surfaceLightest = _useTheme.surfaceLightest;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      content: {
        padding: "10px 10px",
        backgroundColor: surfaceLightest,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      },
      cell: {
        minHeight: 45
      },
      action: {
        padding: "20px 0px"
      }
    });
  }, [surfaceLightest]);
};